import { compareAsc, compareDesc } from "date-fns";
import { cloneDeep } from "lodash";
import InstallmentDto from "../../PaymentContainerClient/dtos/InstallmentDto";

export enum InstallmentDueDateSortDirection {
    Asc = "ASC",
    Desc = "DESC",
}

export default function getInstallmentsSortedByDueDate(
    installments?: InstallmentDto[],
    sortDirection: InstallmentDueDateSortDirection = InstallmentDueDateSortDirection.Asc
): InstallmentDto[] {
    return installments
        ? cloneDeep(installments).sort((installmentA, installmentB) =>
              sortDirection === InstallmentDueDateSortDirection.Asc
                  ? compareAsc(
                        new Date(installmentA.dueDate),
                        new Date(installmentB.dueDate)
                    )
                  : compareDesc(
                        new Date(installmentA.dueDate),
                        new Date(installmentB.dueDate)
                    )
          )
        : [];
}
